import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, LayoutDashboard, Plane, MapPin, BookOpen, Settings, ChevronDown } from 'lucide-react';
const groups = [{
  id: 'services',
  ar: "العمليات والخدمات",
  en: 'Operations & services',
  icon: Plane,
  items: ['operations', 'visas', 'hotels', 'flights', 'buses', 'shipping']
}, {
  id: 'finance',
  ar: "الحسابات والفواتير",
  en: 'Accounts & invoices',
  icon: BookOpen,
  items: ['invoices', 'checkout-payments', 'payments', 'receipts', 'payment-vouchers', 'accounts', 'journal', 'reports']
}, {
  id: 'locations',
  ar: "الدول والمواقع",
  en: 'Locations',
  icon: MapPin,
  items: ['countries', 'cities', 'airports']
}, {
  id: 'management',
  ar: "إدارة الموقع",
  en: 'Site management',
  icon: Settings,
  items: ['users', 'content', 'settings']
}];
export default function AdminNavigation({
  items,
  activeTab,
  language,
  onNavigate
}) {
  __useLocale();
  const activeGroup = groups.find(group => group.items.includes(activeTab))?.id || null;
  const [openGroup, setOpenGroup] = useState(activeGroup);
  useEffect(() => {
    setOpenGroup(activeGroup);
  }, [activeGroup, activeTab]);
  const ar = language === 'ar';
  const linkClass = 'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#6B5B95]';
  return <nav aria-label={__tr(ar ? "التنقل في الإدارة" : 'Admin navigation')} className="flex-1 min-h-0 overflow-y-auto p-3 space-y-1">
      <Link to="/" onClick={onNavigate} className={`${linkClass} text-gray-600 hover:bg-gray-100`}>
        <Home className="w-5 h-5 shrink-0" /><span>{__tr(ar ? "الرئيسية" : 'Home')}</span>
      </Link>
      {__tr(items.some(item => item.id === 'overview') && <Link to="/admin/overview" onClick={onNavigate} aria-current={activeTab === 'overview' ? 'page' : undefined} className={`${linkClass} ${activeTab === 'overview' ? 'bg-[#6B5B95] text-white' : 'text-gray-600 hover:bg-gray-100'}`}>
          <LayoutDashboard className="w-5 h-5 shrink-0" /><span>{__tr(ar ? "لوحة التحكم" : 'Dashboard')}</span>
        </Link>)}
      <div className="border-t !my-3" />
      {__tr(groups.map(group => {
      const children = group.items.map(id => items.find(item => item.id === id)).filter(Boolean);
      if (!children.length) return null;
      const expanded = openGroup === group.id;
      return <div key={group.id}>
            <button type="button" aria-expanded={expanded} aria-controls={`nav-${group.id}`} onClick={() => setOpenGroup(expanded ? null : group.id)} className={`${linkClass} w-full text-start ${activeGroup === group.id ? 'bg-purple-50 text-[#6B5B95] font-semibold' : 'text-gray-600 hover:bg-gray-100'}`}>
              <group.icon className="w-5 h-5 shrink-0" /><span className="flex-1">{__tr(ar ? group.ar : group.en)}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${expanded ? 'rotate-180' : ''}`} />
            </button>
            <div id={`nav-${group.id}`} hidden={!expanded} className="mx-3 my-1 border-s border-purple-100 ps-2 space-y-1">
              {__tr(children.map(item => <Link key={item.id} to={`/admin/${item.id}`} onClick={onNavigate} aria-current={activeTab === item.id ? 'page' : undefined} className={`${linkClass} ${activeTab === item.id ? 'bg-[#6B5B95] text-white' : 'text-gray-600 hover:bg-gray-100'}`}>
                  <item.icon className="w-4 h-4 shrink-0" /><span>{__tr(item.label)}</span>
                </Link>))}
            </div>
          </div>;
    }))}
    </nav>;
}
